import { constants } from '../utils'
import base from './base'

const { headers, url, request } = base

const create = async subscription => {
  const body = JSON.stringify({ subscription })

  return request(url(constants.api.subscription.create), {
    method: 'POST',
    headers: headers(),
    body,
  })
}

const update = async subscription => {
  const body = JSON.stringify({ subscription })

  return request(url(constants.api.subscription.update(subscription.uuid)), {
    method: 'PUT',
    headers: headers(),
    body,
  })
}

const getPdf = async uuid =>
  request(url(constants.api.subscription.pdf(uuid)), {
    method: 'GET',
    headers: headers(true, { 'Content-Type': 'multipart/form-data', Accept: 'Application/pdf' }),
  })

const get = async (cpf, cpfResponsible) =>
  request(url(constants.api.subscription.get(cpf, cpfResponsible)), {
    method: 'GET',
    headers: headers(),
  })

const getSubscriptionAndEnrollment = async (cpf, birthdate) =>
  request(url(constants.api.subscription.getSubscriptionAndEnrollment(cpf, birthdate)), {
    method: 'GET',
    headers: headers(),
  })

const verifyResponsible = async (cpf, birthdate, responsibleCpf) =>
  request(url(constants.api.subscription.verifyResponsible), {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ cpf, birthdate, responsible_cpf: responsibleCpf }),
  })

const validate = async subscription => {
  const body = JSON.stringify({ subscription })

  return request(url(constants.api.subscription.validate), {
    method: 'POST',
    headers: headers(),
    body,
  })
}

const jobStatus = async (jid = null, jobAction = 'create_subscription') =>
  request(url(constants.api.subscription.job_status(jid, jobAction)), {
    method: 'GET',
    headers: headers(),
  })

const confirmInterest = async (cpf, cpfResponsible) =>
  request(url(constants.api.subscription.confirmInterest), {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ cpf, r_cpf: cpfResponsible }),
  })

const returnToWaitingList = async (cpf, cpfResponsible) =>
  request(url(constants.api.subscription.returnToWaitingList), {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ cpf, r_cpf: cpfResponsible }),
  })

const getReturnReceiptPdf = async (cpf, cpfResponsible) =>
  request(url(constants.api.subscription.returnReceiptPdf(cpf, cpfResponsible)), {
    method: 'GET',
    headers: headers(true, { 'Content-Type': 'multipart/form-data', Accept: 'Application/pdf' }),
  })

const subscriptionApi = {
  get,
  create,
  update,
  getPdf,
  validate,
  getSubscriptionAndEnrollment,
  verifyResponsible,
  jobStatus,
  confirmInterest,
  returnToWaitingList,
  getReturnReceiptPdf,
}

export default subscriptionApi
